import {Alert, Box, Button, Container, Fade, IconButton, InputAdornment, Paper, Stack, TextField, Typography, useTheme} from "@mui/material";
import PhoneTextField from "../../../theme/components/PhoneTextField";
import { LoadingButton } from "../../../theme/components/LoadingButton";
import { useEffect, useRef, useState } from "react";
import { useUser } from "../../../lib/hooks";
import http from "../../../lib/services/httpService";
import Toasty from "../../../theme/components/Toasty";
import { VisibilityOffRounded, VisibilityRounded } from "@mui/icons-material";
import AuthCodeInput from "../../../theme/components/AuthCodeInput";
import {setRefreshToken, setToken, setUserData} from "../../../lib/services/jwtService";
import axios from "axios";
import ReCAPTCHA from "react-google-recaptcha";
import {Link} from "react-router-dom";
import useAppConfig from "../../../store/appConfig";

export default function DashboardLogin() {
  //  Initial Props
  const [loginMethod, setLoginMethod] = useState("phoneNumber");
  const [inputData, setInputData] = useState({
    phoneNumber: "",
    maskedNumber: {},
    verifyCode: "",
    username: "",
    password: "",
    showPassword: false,
  });
  const [verifying, setVerifying] = useState(false);
  const [resendTimer, setResendTimer] = useState(120);

  const [pending, setPending] = useState(false);
  const [resendPending, setResendPending] = useState(false);
  const [errors, setErrors] = useState([]);
  const [success, setSuccess] = useState(false);

  const submitBtnRef = useRef(null);
  const maxVerifyCodeLength = 5;
  const apiUrl = useAppConfig(state => state.apiUrl);
  const [isCaptchaChecked, setIsCaptchaChecked] = useState(false);

  const user = useUser({ redirectTo: "/drive", redirectIfFound: true });

  const handleChangeInput = (e) => {
    const {
      target: { value, name },
    } = e;
    if (errors?.length) setErrors(null);
    const newData = { ...inputData };
    newData[name] = value;
    setInputData(newData);
  };
  const handlePhoneInputChange = (number, { dialCode }) => {
    if (errors?.length) setErrors(null);
    const newData = { ...inputData };
    newData.phoneNumber = number;
    newData.maskedNumber.mobileNumber = number.replace(dialCode, "0");
    newData.maskedNumber.countryCode = `00${dialCode}`;
    setInputData(newData);
  };
  const handleChangeAuthInput = (number) => {
    if (errors?.length) setErrors(null);
    const newData = { ...inputData };
    newData.verifyCode = number;
    setInputData(newData);
  };

  const handleGotoVerification = async (e) => {
    e.preventDefault();
    const { phoneNumber, maskedNumber } = inputData;
    if (!phoneNumber || maskedNumber.mobileNumber === "0")
      return setErrors(["شماره موبایل وارد شده صحیح نمی باشد"]);
    if (errors?.length) return;
    setPending(true);
    const { data } = await http.post(`${apiUrl}/user/LoginWithMobile`, inputData.maskedNumber);
    if (data?.isSuccess) {
      setVerifying(true);
    } else {
      setErrors(data.errors);
    }
    setPending(false);
  };
  const handleLoginWithMobile = async (e) => {
    e.preventDefault();
    // if (user) return;
    const { verifyCode } = inputData;
    if (!verifyCode || maxVerifyCodeLength !== verifyCode?.length)
      return setErrors(["لطفا کد اعتبار سنجی را وارد کنید"]);
    // if (!isCaptchaChecked) errors.push('لطفا کپچا را تایید کنید');
    if (errors?.length) return;
    setPending(true);
    const { data } = await http.post(`${apiUrl}/user/VerifyVerificationCode`, {
      ...inputData.maskedNumber,
      code: verifyCode,
    });
    if (data?.isSuccess) {
      const userData = data.value;
      const { access_Token: accessToken, refresh_Token } = userData;
      setToken(accessToken);
      setRefreshToken(refresh_Token);
      axios.defaults.headers.common["Authorization"] = "Bearer " + accessToken;
      delete userData.refresh_Token;
      delete userData.access_Token;
      userData.role = "user";
      setUserData(JSON.stringify(userData));
      setSuccess(true);
      window.location.reload();
    } else {
      setErrors(data.errors);
    }
    setPending(false);
  };
  const handleLoginWithEmail = async (e) => {
    e.preventDefault();
    // if (user) return;
    const { username, password } = inputData;
    let errors = [];
    if (!username) errors.push("لطفا نام کاربری را وارد کنید");
    if (!password) errors.push("لطفا رمز عبور را وارد کنید");
    // if (!isCaptchaChecked) errors.push('لطفا کپچا را تایید کنید');
    if (errors.length) return setErrors(errors);
    setPending(true);
    const { data } = await http.post(`${apiUrl}/user/LoginWithEmail`, {
      username,
      password,
    });
    if (data?.isSuccess) {
      const userData = data.value;
      const { access_Token: accessToken, refresh_Token } = userData;
      setToken(accessToken);
      setRefreshToken(refresh_Token);
      axios.defaults.headers.common["Authorization"] = "Bearer " + accessToken;
      delete userData.refresh_Token;
      delete userData.access_Token;
      userData.role = "user";
      setUserData(JSON.stringify(userData));
      setSuccess(true);
      Toasty.success("شما با موفقیت وارد حسابتان شدید");
      window.location.reload();
    } else {
      setErrors(data.errors);
    }
    setPending(false);
  };
  const handleResendCode = async (e) => {
    setResendPending(true);
    await handleGotoVerification(e);
    setResendTimer(120);
    setResendPending(false);
  };

  function onCaptchaChange(value) {
    setIsCaptchaChecked(Boolean(value));
  }
  function getMinutes(seconds) {
    const value = parseInt(seconds / 60, 10);
    return value.toLocaleString("fa-IR").padStart(2, "۰");
  }
  function getSeconds(seconds) {
    const value = parseInt(seconds % 60, 10);
    return value.toLocaleString("fa-IR").padStart(2, "۰");
  }

  // Resend Verification Code Timer
  useEffect(() => {
    const newValue = resendTimer - 1;
    const timerInterval = setInterval(() => {
      if (!verifying) return;
      setResendTimer(newValue);
    }, 1000);
    if (newValue < 0) clearInterval(timerInterval);
    return () => clearInterval(timerInterval);
  }, [resendTimer, verifying]);

  return (
    <>
      <style jsx global>{`
                  html,body,#root, main {
                  height: 100%;
                  }
            `}</style>
      <Container sx={{py: 5, width: 1, height: 1, display: "flex", alignItems: "center", justifyContent: "center",}}>
        <Paper
            sx={{
              width: 1,
              height: 1,
              maxWidth: { lg: "75%" },
              maxHeight: { lg: "75%" },
              display: "flex",
              justifyContent: "space-between",
              flexDirection: { xs: "column", lg: "row" },
              borderRadius: "8px",
            }}>
          <Box
              sx={{
                width: { xs: "100%", lg: "55%", xl: "40%" },
                height: 1,
                p: { xs: 2, lg: 5 },
                py: { xs: 5 },
                overflowY: "auto",
              }}>
            <Typography
                variant="h1"
                fontSize={{ xs: "1.25rem", lg: "1.5rem" }}
                fontWeight={700}
                textAlign="center">
              ورود / ثبت نام
            </Typography>
            {loginMethod === "phoneNumber" ? (
                <>
                  {!verifying ? (
                      // Enter Number
                      <Stack
                          mt={3}
                          component="form"
                          onSubmit={handleGotoVerification}
                          spacing={2}
                          sx={{ direction: "rtl" }}>
                        <PhoneTextField
                            value={inputData.phoneNumber}
                            onChange={handlePhoneInputChange}
                            name="phoneNumber"
                            label="شماره موبایل"
                            placeholder="+98 912 123 4567"
                            inputProps={{
                              name: "phone",
                              required: true,
                              autoFocus: true,
                              country: "ir",
                            }}
                            InputLabelProps={{ shrink: !!inputData.phoneNumber }}
                            error={!!errors?.length}
                            fullWidth
                        />
                        <Alert
                            severity="info"
                            sx={{ direction: "ltr", fontSize: ".8rem" }}>
                          شماره خود را بدون صفر وارد کنید، مثال: ۹۱۲۱۲۳۴۵۶۷
                        </Alert>
                        {/*<ReCAPTCHA*/}
                        {/*    sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}*/}
                        {/*    theme={themeMode}*/}
                        {/*    onChange={onCaptchaChange}/>*/}
                        <LoadingButton
                            loading={pending && !resendPending}
                            type="submit"
                            fullWidth
                            variant="contained"
                            sx={{ mt: 2.5, py: 1.5 }}
                            disableElevation>
                          مرحله بعد
                        </LoadingButton>
                        <Button
                            disabled={pending}
                            onClick={() => setLoginMethod("email")}
                            sx={{ mt: 2 }}>
                          ورود با ایمیل
                        </Button>
                      </Stack>
                  ) : (
                      // Verification
                      <Stack
                          mt={3}
                          component="form"
                          onSubmit={(e) => handleLoginWithMobile(e)}
                          spacing={2}>
                        <Alert severity="success">
                          کد اعتبار سنجی با موفقیت ارسال شد
                        </Alert>
                        <Typography
                            fontSize=".85rem"
                            fontWeight={500}
                            textAlign="center">
                          لطفا کد ارسال شده را وارد کنید
                        </Typography>
                        <AuthCodeInput
                            onChange={handleChangeAuthInput}
                            onCompleted={async (newNumber) => {
                              await handleChangeAuthInput(newNumber);
                              submitBtnRef.current.click();
                            }}
                            InputProps={{
                              length: maxVerifyCodeLength,
                              allowedCharacters: "numeric",
                            }}
                        />
                        <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between"
                            flexDirection={{ xs: "column", md: "row" }}>
                          <Typography fontSize=".8rem" fontWeight={300}>
                            شماره وارد شده: {inputData?.maskedNumber?.mobileNumber}
                          </Typography>
                          <Box
                              display="flex"
                              alignItems="center"
                              justifyContent="flex-end">
                            <Typography
                                fontSize=".9rem"
                                fontWeight={300}>{`${getMinutes(
                                resendTimer
                            )}:${getSeconds(resendTimer)}`}</Typography>
                            <LoadingButton
                                loading={resendPending}
                                variant="text"
                                onClick={handleResendCode}
                                disabled={Boolean(resendTimer > 0)}
                                sx={{ fontSize: ".8rem", ml: 2 }}>
                              ارسال مجدد کد
                            </LoadingButton>
                          </Box>
                        </Box>
                        <Box>
                          <LoadingButton
                              loading={pending && !resendPending}
                              success={success}
                              ref={submitBtnRef}
                              type="submit"
                              variant="contained"
                              fullWidth
                              sx={{ py: 1.5 }}
                              disableElevation>
                            ورود
                          </LoadingButton>
                          <Button
                              onClick={() => {
                                setVerifying(false);
                                setErrors(null);
                                setPending(false);
                              }}
                              variant="outlined"
                              fullWidth
                              sx={{ mt: 1, py: 1.5 }}
                              disableElevation>
                            بازگشت
                          </Button>
                        </Box>
                      </Stack>
                  )}
                </>
            ) : loginMethod === "email" ? (
                <>
                  {/* Login With Email/Password */}
                  <Stack
                      mt={3}
                      component="form"
                      onSubmit={handleLoginWithEmail}
                      spacing={2}
                      noValidate>
                    <TextField
                        value={inputData.username}
                        onChange={handleChangeInput}
                        fullWidth
                        name="username"
                        label="نام کاربری"
                        placeholder="نام کاربری خود را وارد کنید"
                        required
                    />
                    <TextField
                        value={inputData.password}
                        onChange={handleChangeInput}
                        fullWidth
                        name="password"
                        type={inputData.showPassword ? "text" : "password"}
                        label="رمز عبور"
                        placeholder="رمز عبور خود را وارد کنید"
                        required
                        InputProps={{
                          endAdornment: (
                              <InputAdornment position="start">
                                <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={() =>
                                        setInputData({
                                          ...inputData,
                                          showPassword: !inputData.showPassword,
                                        })
                                    }
                                    onMouseDown={(e) => e.preventDefault()}
                                    edge="end">
                                  {inputData.showPassword ? (
                                      <VisibilityOffRounded />
                                  ) : (
                                      <VisibilityRounded />
                                  )}
                                </IconButton>
                              </InputAdornment>
                          ),
                        }}
                    />
                    {/*<ReCAPTCHA*/}
                    {/*    sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}*/}
                    {/*    theme={themeMode}*/}
                    {/*    onChange={onCaptchaChange}/>*/}
                    <LoadingButton
                        loading={pending}
                        success={success}
                        type="submit"
                        variant="contained"
                        fullWidth
                        sx={{ py: 1.5 }}
                        disableElevation>
                      ورود
                    </LoadingButton>
                    <Button
                        disabled={pending}
                        onClick={() => setLoginMethod("phoneNumber")}
                        sx={{ mt: 2 }}>
                      ورود با موبایل
                    </Button>
                  </Stack>
                </>
            ) : null}
            <Link to="/">
              <Button fullWidth sx={{ mt: 1.5 }}>بازگشت به صفحه اصلی</Button>
            </Link>
            <Fade in={!!errors?.length}>
              <Stack mt={2.5} spacing={1} sx={{ direction: "ltr" }}>
                {errors?.map((err, index) => (
                    <Alert key={index} severity="error">
                      {err}
                    </Alert>
                ))}
              </Stack>
            </Fade>
          </Box>
          <Box
              component="img"
              alt="Cover"
              src="/assets/image/background/login-background.jpg"
              sx={{
                order: { xs: -1, lg: "initial" },
                width: { xs: "100%", lg: "50%", xl: "60%" },
                height: { xs: "25%", lg: "100%" },
                background: (theme) => theme.palette.primary.main,
                objectFit: "cover",
                borderRadius: { xs: "8px 8px 0 0", lg: "0 8px 8px 0" },
                boxShadow: {
                  xs: "0 16px 32px -6px rgb(0 109 236 / 25%)",
                  lg: "-16px 0 32px -6px rgb(0 109 236 / 25%)",
                },
              }}
          />
        </Paper>
      </Container>
    </>
  );
}
